import { render, staticRenderFns } from "./AgeTechServiceDetail.vue?vue&type=template&id=58ee5f0b"
import script from "./AgeTechServiceDetail.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports